import { AppButtonIcon } from '@/components/App/AppButtonIcon';
import { AppMappingStates } from '@/components/App/AppPageBaseView';
import router from '@/router/router';
import { Icons, Routes } from '@/utils';
import Colors from '@/utils/colors';
import { NBadge, NButton, NIcon } from 'naive-ui';
import { defineComponent } from 'vue';

export const SuperChatButton = defineComponent({
	name: 'SuperChatButton',

	extends: AppMappingStates,

	computed: {},

	render() {
		if (!this.isBackOffice) return;

		return (
			<NBadge dot processing>
				<AppButtonIcon
					icon={Icons.ChatMessage}
					onClick={() => router.push({ name: Routes.CustomerChat })}
				/>
			</NBadge>
		);
	},
});
